export default [
  {
    path: "/bookings",
    name: "Booking",
    meta: { title: "Bookings" },
    component: () => import("@/modules/bookings/views/BookingList.vue"),
  },
  {
    path: "/bookings/view/:id",
    name: "ViewBooking",
    meta: { title: "Booking Details" },
    component: () => import("@/modules/bookings/views/Bookings.vue"),
  },
];
